import {
  PARTNER_BANK_JOURNEY_STAGES,
  PartnerBankJourneyCardResponse,
  PartnerBankJourneyStage,
} from '@interfaces/partners/responses/partner-bank-journey.response';
import { KanbanColumnTotal } from '@shared/components/kanban-board/kanban-board.types';

/**
 * Soma de exibição dos bancos de uma etapa: uma linha por moeda, BRL primeiro (card 3707). Não é cálculo
 * financeiro, só agrupa os valores que o backend mandou. Usada pela coluna do quadro e pelo resumo do cabeçalho
 * (card 3752), para os dois mostrarem o mesmo número.
 */
export function bankJourneyTotalsByCurrency(
  cards: readonly PartnerBankJourneyCardResponse[]
): KanbanColumnTotal[] {
  const byCurrency = new Map<string, KanbanColumnTotal>();
  for (const card of cards) {
    const currency = (card.currencyCode || 'BRL').toUpperCase();
    const current = byCurrency.get(currency) ?? { currency, count: 0, value: 0 };
    byCurrency.set(currency, {
      currency,
      count: current.count + 1,
      value: current.value + (card.value ?? 0),
    });
  }
  return [...byCurrency.values()].sort((a, b) =>
    a.currency === 'BRL' ? -1 : b.currency === 'BRL' ? 1 : a.currency.localeCompare(b.currency)
  );
}

/** Posição da etapa na ordem das colunas; etapa desconhecida vai para o fim. */
export function bankJourneyStageOrder(stage: PartnerBankJourneyStage | string): number {
  const index = PARTNER_BANK_JOURNEY_STAGES.findIndex(s => s.value === stage);
  return index < 0 ? PARTNER_BANK_JOURNEY_STAGES.length : index;
}

/** Tom da etiqueta da etapa (lista e resumo): mesma régua de cor nos dois. */
export type BankJourneyStageTone = 'neutral' | 'warning' | 'info' | 'danger' | 'success';

export const BANK_JOURNEY_STAGE_TONES: Readonly<
  Record<PartnerBankJourneyStage, BankJourneyStageTone>
> = {
  Presentation: 'neutral',
  DocumentSubmission: 'warning',
  CreditAnalysis: 'info',
  Rejected: 'danger',
  Approved: 'success',
  Disbursement: 'success',
};
